"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentWithFallback = exports.createFallbackComponent = void 0;
const tslib_1 = require("tslib");
/* eslint-disable react/no-unescaped-entities */
const core_1 = require("@bluebase/core");
const react_1 = tslib_1.__importDefault(require("react"));
const __1 = require("../");
/**
 * Creates a component that displays an error message with the Component name and the node module
 * name of the plugin that registers this plugin.
 */
const createFallbackComponent = ({ name, moduleName }) => {
    const Component = () => (react_1.default.createElement(__1.View, { style: {
            alignItems: 'center',
            backgroundColor: 'rgba(255,0,0,.05)',
            borderColor: 'red',
            borderRadius: 4,
            borderWidth: 1,
            padding: 8,
        } },
        react_1.default.createElement(__1.Body1, { style: { color: 'red' } },
            "\"",
            react_1.default.createElement(__1.Body1, { style: { color: 'red', fontWeight: 'bold' }, testID: "fallback-name" }, name),
            "\" component not found!"),
        react_1.default.createElement(__1.Body2, { style: { marginTop: 8 } },
            "Did you forget to add",
            ' ',
            react_1.default.createElement(__1.Body2, { style: {
                    backgroundColor: 'rgba(255,0,0,.1)',
                    borderRadius: 4,
                    fontWeight: 'bold',
                    paddingHorizontal: 8,
                    paddingVertical: 4,
                    // textDecorationLine: 'underline',
                }, testID: "fallback-module-name" }, moduleName),
            ' ',
            "plugin in your project?")));
    Component.displayName = name;
    return Component;
};
exports.createFallbackComponent = createFallbackComponent;
/**
 * Like getComponent, but with a fallback component, if the original component is not found.
 */
function getComponentWithFallback(opts) {
    const Fallback = (0, exports.createFallbackComponent)(opts);
    return (...keys) => (0, core_1.getComponent)(...keys, Fallback);
}
exports.getComponentWithFallback = getComponentWithFallback;
